/** Тексты окна: Забежка закрыта. */
import type { MessageBundle } from "../../../i18n";

const en = {
  "win.runEnded.title": "Run over",
  "win.runEnded.text": "You were away for over 10 minutes — boosts are reset. Your coins and upgrades are safe.",
  "win.runEnded.rejected": "The server didn't count the last wave, so you're back on it. Your upgrades are safe.",
  "win.runEnded.fight": "To battle",
} as const;

type Key = keyof typeof en;

const ru: Record<Key, string> = {
  "win.runEnded.title": "Забежка закрыта",
  "win.runEnded.text": "Тебя не было больше 10 минут — усиления сброшены. Монеты и прокачка на месте.",
  "win.runEnded.rejected": "Сервер не засчитал последнюю волну, поэтому ты снова на ней. Прокачка на месте.",
  "win.runEnded.fight": "В бой",
};

const uk: Record<Key, string> = {
  "win.runEnded.title": "Забіг закрито",
  "win.runEnded.text": "Тебе не було понад 10 хвилин, підсилення скинуто. Монети й прокачка на місці.",
  "win.runEnded.rejected": "Сервер не зарахував останню хвилю, тому ти знову на ній. Прокачка на місці.",
  "win.runEnded.fight": "У бій",
};

export const messages: MessageBundle<Key> = { en, ru, uk };
